export enum TSSchadenObjektTyp {
    KULTURLAND = <any> 'KULTURLAND',
    OBSTBAUM_REBSTOECKE = <any> 'OBSTBAUM_REBSTOECKE',
    STRASSEN_WEGE = <any> 'STRASSEN_WEGE',
    BRUECKEN_DURCHLAESSE = <any> 'BRUECKEN_DURCHLAESSE',
    UFER_BACHBAUTEN = <any> 'UFER_BACHBAUTEN',
    STUETZMAUER_REBMAUERN = <any> 'STUETZMAUER_REBMAUERN',
    HAUSUMSCHWUNG = <any> 'HAUSUMSCHWUNG',
    EINFRIEDUNG = <any> 'EINFRIEDUNG',
    LEITUNGEN_AUSSERHALB_DER_GEBAEUDE = <any> 'LEITUNGEN_AUSSERHALB_DER_GEBAEUDE',
    WALD = <any> 'WALD',
}

export function getTSSchadenObjektValues(): Array<TSSchadenObjektTyp> {
    return [
        TSSchadenObjektTyp.KULTURLAND,
        TSSchadenObjektTyp.OBSTBAUM_REBSTOECKE,
        TSSchadenObjektTyp.STRASSEN_WEGE,
        TSSchadenObjektTyp.BRUECKEN_DURCHLAESSE,
        TSSchadenObjektTyp.UFER_BACHBAUTEN,
        TSSchadenObjektTyp.STUETZMAUER_REBMAUERN,
        TSSchadenObjektTyp.HAUSUMSCHWUNG,
        TSSchadenObjektTyp.EINFRIEDUNG,
        TSSchadenObjektTyp.LEITUNGEN_AUSSERHALB_DER_GEBAEUDE,
        TSSchadenObjektTyp.WALD
    ];
}



// WEBPACK FOOTER //
// ./src/app/models/enums/TSSchadenObjekt.ts